// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2W_G4","name":"Header_name__23mlD","birthday":"Header_birthday__3x6DE","skeleton":"Header_skeleton__32fb6"};